
export default function (lic) {

    let licitacao = {}

    licitacao.licitacaoId = lic ? lic.licitacaoId : null
    licitacao.assunto = lic ? lic.assunto : ""
    licitacao.texto = lic ? lic.texto : ""
    licitacao.responsavel = lic ? lic.responsavel : ""
    licitacao.dataPublicacao = lic ? lic.dataPublicacao : null
    licitacao.dataValidade = lic ? lic.dataValidade : null
    licitacao.usuarioId = lic ? lic.usuarioId : null
    licitacao.tipoLicitacao = lic ? lic.tipoLicitacao : { tipoLicitacaoId: null, nome: "" }
    licitacao.situacaoLicitacao = lic ? lic.situacaoLicitacao : { situacaoLicitacaoId: null, nome: "" }
    licitacao.numero = lic ? lic.numero : ""
    licitacao.ano = lic ? lic.ano : ""
    licitacao.itensLicitacao = lic ? lic.itensLicitacao : []

    /* itemLicitacao =
    {
        itemLicitacaoId: null,
        arquivo: null,
        descricao: null,
        data: null,
        externo: null,
        linkExterno: null
    } */

    return licitacao
}
